import React, { useState } from "react";
import { Translate } from "react-localize-redux";
import { NavLink } from "react-router-dom";
import BonusesIcon from "../../assets/icons/BonusesIcon.jsx";
import DocumentsIcon from "../../assets/icons/DocumentsIcon.jsx";
import HistoryIcon from "../../assets/icons/HistoryIcon.jsx";
import NotificationIcon from "../../assets/icons/NotificationIcon.jsx";
import ProfileIcon from "../../assets/icons/ProfileIcon.jsx";

import MoneyIcon from "@pages/profile-v2/assets/icons/Money.jsx";
import WithdrawIcon from "@pages/profile-v2/assets/icons/Withdraw.webp";

import { LinkWrapper, SidebarMenuWrapper } from "./elements";

const SidebarMenu = ({ isWithdrawOrDepositPage }) => {
	const [activeIcon, setActiveIcon] = useState(null);

	return (
		<Translate>
			{({ translate }) => (
				<SidebarMenuWrapper>
					{isWithdrawOrDepositPage ? (
						<>
							<LinkWrapper isActive={activeIcon === "deposit"}>
								<MoneyIcon />
								<NavLink
									data-testid="button-deposit-mode-deposit"
									to="/profile/deposit"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("deposit");
										}
										return match;
									}}>
									{translate("Deposit")}
								</NavLink>
							</LinkWrapper>
							<LinkWrapper isActive={activeIcon === "withdraw"}>
								<img src={WithdrawIcon} />
								<NavLink
									data-testid="button-deposit-mode-withdraw"
									to="/profile/withdraw"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("withdraw");
										}
										return match;
									}}>
									{translate("Withdraw")}
								</NavLink>
							</LinkWrapper>
						</>
					) : (
						<>
							<LinkWrapper isActive={activeIcon === "settings"}>
								<ProfileIcon color="#F7F7F7" />
								<NavLink
									data-testid="button-profile-menu-settings"
									to="/profile/settings"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("settings");
										}
										return match;
									}}>
									{translate("Profile")}
								</NavLink>
							</LinkWrapper>
							<LinkWrapper isActive={activeIcon === "inbox"}>
								<NotificationIcon />
								<NavLink
									data-testid="button-profile-menu-inbox"
									to="/profile/inbox"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("inbox");
										}
										return match;
									}}>
									{translate("Notifications")}
								</NavLink>
							</LinkWrapper>
							<LinkWrapper isActive={activeIcon === "history"}>
								<HistoryIcon />
								<NavLink
									data-testid="button-profile-menu-history"
									to="/profile/history"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("history");
										}
										return match;
									}}>
									{translate("History")}
								</NavLink>
							</LinkWrapper>
							<LinkWrapper isActive={activeIcon === "documents"}>
								<DocumentsIcon />
								<NavLink
									data-testid="button-profile-menu-documents"
									to="/profile/documents"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("documents");
										}
										return match;
									}}>
									{translate("Documents")}
								</NavLink>
							</LinkWrapper>
							<LinkWrapper isActive={activeIcon === "bonuses"}>
								<BonusesIcon />
								<NavLink
									data-testid="button-profile-menu-bonuses"
									to="/profile/bonuses"
									activeClassName="active-link"
									isActive={(match) => {
										if (match) {
											setActiveIcon("bonuses");
										}
										return match;
									}}>
									{translate("My Bonuses")}
								</NavLink>
							</LinkWrapper>
						</>
					)}
				</SidebarMenuWrapper>
			)}
		</Translate>
	);
};

export default SidebarMenu;
